import { DefaultColors, styled } from '@goodfynd/react-web.design-system';

export const StyledBgMobileContainer = styled('div', {
  position: 'relative',
});

export const StyledBgMobile = styled('div', {
  backgroundPosition: 'right',
  backgroundSize: 'cover',
  display: 'none',
  height: 345,
  marginTop: -24,
  width: '100%',
  '@xs': {
    display: 'block',
  },
});

export const StyledMission = styled('article', {
  maxWidth: 555,
  'h1,p': {
    color: DefaultColors.Neutral13,
  },
});

export const StyledPanelContent = styled('div', {
  maxWidth: 1200,
});

export const StyledPanelMission = styled('section', {
  backgroundAttachment: 'initial',
  backgroundColor: 'var(--BackgroundBase1)',
  backgroundPosition: 'bottom',
  backgroundSize: 'cover',
  marginTop: -55,
  maxHeight: 625,
  padding: 150,
  '@mdMax': {
    marginTop: 0,
    padding: 32,
    paddingRight: 240,
  },
  '@xs': {
    backgroundImage: 'none !important',
    borderBottom: '4px solid $Neutral02',
    marginTop: 0,
    padding: 32,
  },
});
